import { Layers } from 'lucide-react'
import UtxoManager from '../pages/utxo-manager'

export default {
	icon: Layers,
	name: 'Manage UTXOs',
	component: UtxoManager,
	heading: 'UTXO Manager',
	featured: false,
	filter: ({ loggedIn }: any) => {
		return loggedIn
	}
}
